import { PageWrapper } from "@/shared/components"
import { useCurrentUser } from "@/shared/hooks/use-current-user"
import { AuditorAdministrationWrapper } from "./auditor-administration-wrapper"
import { ConsumerAdministrationWrapper } from "./consumer-administration-wrapper"

export const AdministrationWrapper = () => {
  // Helpers
  const { isAuditor, isCompany } = useCurrentUser()

  return (
    <PageWrapper>
      {isAuditor && <AuditorAdministrationWrapper />}
      {isCompany && <ConsumerAdministrationWrapper />}
    </PageWrapper>
  )
}
